export const tokens = {
    titleSize: 14,
    list: {
        marginTop: 20,
        gap: 20,
    },
    link: {
        gap: 6,
        fontSize: 15,
        iconSize: 16,
    },
    suggestLink: {
        marginTop: 32,
        padding: 6,
        fontSize: 14,
        radius: 4,
    },
};
